import { render, staticRenderFns } from "./standart-draggable-alert.vue?vue&type=template&id=766571fb&"
import script from "./standart-draggable-alert.vue?vue&type=script&lang=ts&"
export * from "./standart-draggable-alert.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports